/** Icons generated by create-react-icons. Don't edit this file directly. **/
import React from "react";
import PropTypes from "prop-types";

export function Tools(props) {
  const { size, color, ...other } = props;
  return (
    <svg viewBox="0 0 24 24" fill="none" height={size} width={size} {...other}>
      <path
        d="M11.835 15L16.835 20C17.663 20.828 19.007 20.828 19.835 20C20.663 19.172 20.663 17.828 19.835 17L14.835 12"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.84 7.00001L10.34 10.5M20.916 5.84701C20.94 5.87001 20.958 5.90001 20.967 5.93201C21.437 7.49901 21.073 9.26201 19.835 10.5C18.584 11.751 16.797 12.109 15.218 11.617L6.871 19.964C6.058 20.777 4.732 20.838 3.891 20.054C3.007 19.231 2.989 17.847 3.835 17L12.218 8.61701C11.726 7.03801 12.084 5.25101 13.335 4.00001C14.573 2.76201 16.336 2.39801 17.903 2.86801C17.935 2.87801 17.965 2.89501 17.988 2.91901L18.15 3.08101C18.228 3.15901 18.228 3.28601 18.15 3.36401L15.515 6.00001L17.835 8.32001L20.471 5.68401C20.549 5.60601 20.676 5.60601 20.754 5.68401L20.916 5.84701V5.84701ZM2.933 4.29301L3.607 6.31601C3.743 6.72501 4.125 7.00001 4.556 7.00001H6.835V4.72101C6.835 4.29101 6.56 3.90801 6.151 3.77201L4.128 3.09801C3.948 3.03801 3.75 3.08501 3.616 3.21901L3.054 3.78101C2.92 3.91501 2.873 4.11301 2.933 4.29301V4.29301Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

Tools.defaultProps = {
  color: "currentColor",
  size: 24,
};

Tools.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
